class DetailsDisclosure extends HTMLElement {
  constructor() {
    super(), this.mainDetailsToggle = this.querySelector("details"), this.addEventListener("keyup", this.onKeyUp), this.mainDetailsToggle.addEventListener("focusout", this.onFocusOut.bind(this))
  }
  onKeyUp(e) {
    if ("ESCAPE" === e.code.toUpperCase()) {
      const t = e.target.closest("details[open]");
      if (t) {
        const i = t.querySelector("summary");
        t.removeAttribute("open"), i.focus()
      }
    }
  }
  onFocusOut() {
    setTimeout(() => {
      this.contains(document.activeElement) || this.close()
    })
  }
  close() {
    this.mainDetailsToggle.removeAttribute("open")
  }
}
customElements.define("details-disclosure", DetailsDisclosure);
class ShareButton extends DetailsDisclosure {
  constructor() {
    super(), this.elements = {
      shareButton: this.querySelector("button"),
      successMessage: this.querySelector('[id^="ShareMessage"]'),
      urlInput: this.querySelector("input")
    }, navigator.canShare ? (this.mainDetailsToggle.removeAttribute("hidden"), this.mainDetailsToggle.addEventListener("toggle", this.toggleDetails.bind(this)), this.mainDetailsToggle.querySelector("button").addEventListener("click", this.copyToClipboard.bind(this))) : (this.mainDetailsToggle.setAttribute("hidden", ""), this.elements.shareButton.classList.remove("hidden"), this.elements.shareButton.addEventListener("click", () => {
      navigator.share({
        url: document.location.href,
        title: document.title
      })
    }))
  }
  toggleDetails() {
    this.mainDetailsToggle.open || this.elements.successMessage.classList.add("hidden")
  }
  copyToClipboard() {
    navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
      this.elements.successMessage.classList.remove("hidden"), this.elements.successMessage.setAttribute("aria-hidden", !1), setTimeout(() => {
        this.elements.successMessage.setAttribute("aria-hidden", !0)
      }, 6e3)
    })
  }
}
customElements.define("share-button", ShareButton);
class QuantityInput extends HTMLElement {
  constructor() {
    super(), this.input = this.querySelector("input"), this.changeEvent = new Event("change", {
      bubbles: !0
    }), this.querySelectorAll("button").forEach(e => e.addEventListener("click", this.onButtonClick.bind(this)))
  }
  onButtonClick(e) {
    e.preventDefault();
    var t = this.input.value;
    "plus" === e.target.name ? this.input.stepUp() : this.input.stepDown(), t !== this.input.value && this.input.dispatchEvent(this.changeEvent)
  }
}
customElements.define("quantity-input", QuantityInput);
class PickupAvailability extends HTMLElement {
  constructor() {
    super(), this.hasAttribute("available") && (this.errorHtml = this.querySelector("template").content.firstElementChild.cloneNode(!0), this.onClickRefreshList = this.onClickRefreshList.bind(this), this.fetchAvailability(this.dataset.variantId))
  }
  fetchAvailability(e) {
    e = `${this.dataset.baseUrl}variants/${e}/?section_id=pickup-availability`;
    fetch(e).then(e => e.text()).then(e => {
      e = (new DOMParser).parseFromString(e, "text/html").querySelector(".shopify-section");
      this.renderPreview(e)
    }).catch(e => {
      this.querySelector(".btn--link") && this.querySelector(".btn--link").removeEventListener("click", this.onClickRefreshList), this.renderError()
    })
  }
  onClickRefreshList(e) {
    this.fetchAvailability(this.dataset.variantId)
  }
  renderError() {
    this.innerHTML = "", this.appendChild(this.errorHtml), this.querySelector(".btn--link").addEventListener("click", this.onClickRefreshList)
  }
  renderPreview(e) {
    const t = document.querySelector("pickup-availability-drawer");
    if (t && t.remove(), !e.querySelector("pickup-availability-preview")) return this.innerHTML = "", void this.removeAttribute("available");
    this.innerHTML = e.querySelector("pickup-availability-preview").outerHTML, this.setAttribute("available", ""), document.body.appendChild(e.querySelector("pickup-availability-drawer")), this.querySelector(".btn--link").addEventListener("click", e => {
      document.querySelector("pickup-availability-drawer").show(e.target)
    })
  }
}
customElements.define("pickup-availability", PickupAvailability);
class PickupAvailabilityDrawer extends HTMLElement {
  constructor() {
    super(), this.onBodyClick = this.handleBodyClick.bind(this), this.querySelector("button").addEventListener("click", () => {
      this.hide()
    }), this.addEventListener("keyup", () => {
      "ESCAPE" === event.code.toUpperCase() && this.hide()
    })
  }
  handleBodyClick(e) {
    const t = e.target;
    t == this || t.closest("pickup-availability-drawer") || "ShowPickupAvailabilityDrawer" == t.id || this.hide()
  }
  hide() {
    this.removeAttribute("open"), document.body.removeEventListener("click", this.onBodyClick), this.scrollY = document.body.style.top, document.body.style.top = "", document.body.classList.remove("overflow-hidden-fixed"), window.scrollTo({
      left: 0,
      top: -1 * parseInt(this.scrollY || "0"),
      behavior: "instant"
    }), removeTrapFocus(this.focusElement)
  }
  show(e) {
    this.focusElement = e, this.setAttribute("open", ""), document.body.addEventListener("click", this.onBodyClick), document.body.style.top = `-${window.pageYOffset}px`, document.body.classList.add("overflow-hidden-fixed"), trapFocus(this)
  }
}
customElements.define("pickup-availability-drawer", PickupAvailabilityDrawer);
class VariantSelects extends HTMLElement {
  constructor() {
    super(), this.isChanging = !1, this.linkOptionsSelectors(), this.selectVariant(), this.addEventListener("change", this.onVariantChange), this.addEventListener("sliderChange", this.onSliderChange)
  }
  onVariantChange() {
    this.isChanging || (this.isChanging = !0, this.updateOptions(), this.updateMasterId(), this.toggleAddButton(!0, "", !1), this.updatePickupAvailability(), this.currentVariant ? (this.updateMedia(), this.updateURL(), this.updateVariantSelected(), this.renderProductInfo()) : (this.toggleAddButton(!0, "", !0), this.setUnavailable()), this.isChanging = !1)
  }
  onSliderChange() {
    this.isChanging || (this.isChanging = !0, this.updateOptions(), this.updateMasterId(), this.toggleAddButton(!0, "", !1), this.updatePickupAvailability(), this.currentVariant ? (this.updateURL(), this.updateVariantSelected(), this.renderProductInfo()) : (this.toggleAddButton(!0, "", !0), this.setUnavailable()), this.isChanging = !1)
  }
  updateOptions() {
    this.options = Array.from(this.querySelectorAll("[data-options-index]"), e => e.value)
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find(e => !e.options.map((e, t) => this.options[t] === e).includes(!1))
  }
  linkOptionsSelectors() {
    let t = {};
    var i = this,
      e = this.getVariantData();
    let s = !1,
      n = !1;
    if (e) {
      for (var o = 0; o < e.length; o++) {
        var a, r = e[o];
        r.available && (t.root = t.root || [], t.root.push(r.option1), t.root = theme.utils.uniq(t.root), null == r.option2 && null == r.option3 || (a = r.option1, s = 0 < this.querySelectorAll('[data-options-index="1"]').length || 0 < this.querySelectorAll('[data-options-index="2"]').length, t[a] = t[a] || [], t[a].push(r.option2), t[a] = theme.utils.uniq(t[a])), null != r.option2 && null != r.option3 && (a = r.option1 + " / " + r.option2, n = 0 < this.querySelectorAll('[data-options-index="1"]').length && 0 < this.querySelectorAll('[data-options-index="2"]').length, t[a] = t[a] || [], t[a].push(r.option3), t[a] = theme.utils.uniq(t[a])))
      }
      this.updateOptionsInSelector(0, t), (s || n) && this.updateOptionsInSelector(1, t), s && n && this.updateOptionsInSelector(2, t), (s || n) && this.querySelectorAll('[data-options-index="0"]').forEach(e => e.addEventListener("change", function () {
        return i.updateOptionsInSelector(1, t), s && n && i.updateOptionsInSelector(2, t), !0
      })), s && n && this.querySelectorAll('[data-options-index="1"]').forEach(e => e.addEventListener("change", function () {
        return i.updateOptionsInSelector(2, t), !0
      }))
    }
  }
  updateOptionsInSelector(e, t) {
    var i = 0 < this.querySelectorAll("select[data-options-index]").length;
    switch (e) {
      case 0:
        var s = "root";
        break;
      case 1:
        var s = (i ? this.querySelector('[data-options-index="0"]') : this.querySelector('input[data-options-index="0"]:checked')).value;
        break;
      case 2:
        i ? (s = this.querySelector('[data-options-index="0"]').value, s += " / " + this.querySelector('[data-options-index="1"]').value) : (s = this.querySelector('input[data-options-index="0"]:checked').value, s += " / " + this.querySelector('input[data-options-index="1"]:checked').value)
    }
    var n = t[s];
    void 0 !== n && this.querySelectorAll(i ? '[data-options-index="' + e + '"] option' : 'input[data-options-index="' + e + '"]').forEach(e => {
      n.includes(e.value) ? e.removeAttribute("disabled", "disabled") : e.setAttribute("disabled", "disabled")
    })
  }
  updateMedia() {
    if (this.currentVariant && this.currentVariant.featured_media || this.currentVariant.featured_media) {
      const t = document.querySelector(`.product__media--main [data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`);
      if (t) {
        const i = document.querySelector(`#ProductsImages-${this.dataset.section} .product__media--main`),
          s = document.querySelector("sticky-atc");
        var e;
        780 <= document.documentElement.clientWidth ? "true" == i.getAttribute("data-active") ? (e = parseInt(t.getAttribute("data-index")), i.swiper.slideToLoop(e)) : window.setTimeout(() => {
          var e = t.getBoundingClientRect().top + window.scrollY;
          theme.utils.scrollToSmoothly(e, 400)
        }, 300) : "true" == i.getAttribute("datamob-active") && (e = parseInt(t.getAttribute("data-index")), i.swiper.slideToLoop(e)), s && s.querySelector(".sticky_atc__image") && this.currentVariant.featured_image.src && (s.querySelector(".sticky_atc__image img").src = this.currentVariant.featured_image.src)
      }
    }
  }
  updateURL() {
    this.currentVariant && window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`)
  }
  updateVariantSelected() {
    var s = this;
    const e = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    e.forEach(e => {
      const t = e.querySelector('input[name="id"]'),
        i = document.querySelector("sticky-atc");
      t && (t.value = s.currentVariant.id, t.dispatchEvent(new Event("change", {
        bubbles: !0
      }))), i && (i.querySelector('[name="id"]').value = s.currentVariant.id)
    })
  }
  updatePickupAvailability() {
    const e = document.querySelector("pickup-availability");
    e && (this.currentVariant && this.currentVariant.available ? e.fetchAvailability(this.currentVariant.id) : (e.removeAttribute("available"), e.innerHTML = ""))
  }
  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`).then(e => e.text()).then(e => {
      const t = (new DOMParser).parseFromString(e, "text/html");
      var i = `price-${this.dataset.section}`;
      let s = document.getElementById(i),
        n = t.getElementById(i);
      if (n && s && (s.innerHTML = n.innerHTML), document.querySelector(`#price-${this.dataset.section}`) && (document.querySelector(`#price-${this.dataset.section} .price`).classList.remove("price-visibility-hidden"), document.querySelector(`#price-${this.dataset.section} .product__select_variant`).classList.add("hide")), document.querySelector(".product-section .product__avaibility")) {
        var o = document.querySelector(".product-section .product__avaibility");
        const a = o.parentNode;
        e = t.querySelector(".product-section .product__avaibility").cloneNode(!0);
        a.replaceChild(e, o)
      }
      0 < document.querySelectorAll(".shopify-payment-button").length && document.querySelectorAll(".shopify-payment-button").forEach(e => {
        e.classList.remove("visibility-hidden")
      }), this.toggleAddButton(!this.currentVariant.available, theme.strings.soldOut), this.dispatchEvent(new CustomEvent("variantRendered")), i = `promotion-${this.dataset.section}`, s = document.getElementById(i), n = t.getElementById(i), n && s && (n.classList.contains("hide") ? s.classList.add("hide") : (s.innerHTML = n.innerHTML, s.classList.remove("hide")))
    })
  }
  toggleAddButton(e = !0, t, i) {
    const s = document.getElementById(`product-form-${this.dataset.section}`) ? document.getElementById(`product-form-${this.dataset.section}`).querySelector('[name="add"]') : "";
    s && (e ? (s.setAttribute("disabled", !0), t && (s.querySelector("span:first-child").textContent = t), s.querySelector(".button_atc_icon") && s.querySelector(".button_atc_icon").classList.add("hide")) : (s.querySelector(".button_atc_icon") && s.querySelector(".button_atc_icon").classList.remove("hide"), s.removeAttribute("disabled"), s.querySelector("span:first-child").textContent = theme.strings.addToCart))
  }
  setUnavailable() {
    (document.getElementById(`product-form-${this.dataset.section}`) ? document.getElementById(`product-form-${this.dataset.section}`).querySelector('[name="add"]') : "") && (this.toggleAddButton(!0, theme.strings.unavailable), document.querySelector(`#price-${this.dataset.section}`) && (document.querySelector(`#price-${this.dataset.section} .price`).classList.add("price-visibility-hidden"), document.querySelector(`#price-${this.dataset.section} .product__select_variant`).classList.remove("hide")), 0 < document.querySelectorAll(".shopify-payment-button").length && document.querySelectorAll(".shopify-payment-button").forEach(e => {
      e.classList.add("visibility-hidden")
    }))
  }
  getVariantData() {
    return this.variantData = this.variantData || JSON.parse(this.querySelector("[id^=VariantJson-").textContent), this.variantData
  }
  createVariantImage(e) {
    const a = {};
    return e.variants.forEach(n => {
      if (void 0 !== n.featured_image && null !== n.featured_image) {
        const o = n.featured_image.src.split("?")[0].replace(/http(s)?:/, "");
        a[o] = a[o] || {}, e.options.forEach((e, t) => {
          var i = n.options[t],
            s = `option-${t}`;
          void 0 === a[o][s] ? a[o][s] = i : null !== (t = a[o][s]) && t !== i && (a[o][s] = null)
        })
      }
    }), a
  }
  selectVariant() {
    var e = this;
    const t = document.querySelector("[id^=ProductJson-");
    if (t) {
      const i = t.id.replace("ProductJson-", "shopify-section-");
      if (1 < document.querySelectorAll("#" + i + ' .product__media.image-container img[src*="cdn/shop/"]').length) {
        const s = JSON.parse(t.innerHTML),
          n = this.createVariantImage(s);
        1 < s.variants.length && document.addEventListener("DOMContentLoaded", function () {
          (!(780 <= document.documentElement.clientWidth) || document.querySelector("#" + i + ' .product__media--main[data-active="true"]')) && e.listenChangeSlider(i, s, n)
        })
      }
    }
  }
  listenChangeSlider(n, o, a) {
    var r = this,
      i = document.querySelector("#" + n + " .product__media--main");
    const s = new MutationObserver(function (e) {
      for (var t of e) "attributes" === t.type && "class" === t.attributeName && i.classList.contains("swiper-initialized") && (i.swiper.on("activeIndexChange", function (e) {
        const {
          slides: t,
          activeIndex: i
        } = e, s = {};
        s.target = t[i].querySelector('.product__media img[src*="cdn/shop/"]'), void 0 !== s.target && r.updateVariant(s, n, o, a)
      }), s.disconnect())
    });
    s.observe(i, {
      attributes: !0
    })
  }
  updateVariant(e, t, i, a) {
    var r = this;
    const c = e.target.src.split("?")[0].replace(/http(s)?:/, "");
    let d, l = !1;
    void 0 !== a[c] && (r.options = [], i.variants.forEach((e, i) => {
      var s = a[c][`option-${i}`];
      if (null != s) {
        const o = document.querySelectorAll("#" + t + " [data-options-index]");
        var n = o[i].options || o;
        for (let e, t = 0; e = n[t]; t += 1)
          if (e.value === s) return r.options.push(s), l = !0, o[i].options ? o[i].value = s : (o[t].checked = !0, o[t].dispatchEvent(new Event("change"))), void(d = o[i].closest(".variant-select"))
      }
    }), l && d.dispatchEvent(new CustomEvent("sliderChange")))
  }
}
customElements.define("variant-selects", VariantSelects);
class VariantRadios extends VariantSelects {
  constructor() {
    super()
  }
  updateOptions() {
    const e = Array.from(this.querySelectorAll("fieldset"));
    this.options = e.map(e => Array.from(e.querySelectorAll("input")).find(e => e.checked).value)
  }
}
customElements.define("variant-radios", VariantRadios);
class Magnify extends HTMLElement {
  constructor() {
    super();
    var e = this;
    780 <= document.documentElement.clientWidth && this.addEventListener("mouseenter", function () {
      e.magnify()
    }), window.on("resize", theme.utils.debounce(300, function () {
      780 <= document.documentElement.clientWidth ? this.addEventListener("mouseenter", function () {
        e.magnify()
      }) : e.removeMagnify()
    }))
  }
  magnify() {
    var t = this,
      i = this.querySelector("img");
    if (null !== i) {
      if (this.querySelector(".magnify__large-img")) var s = this.querySelector(".magnify__large-img");
      else {
        (s = document.createElement("div")).classList.add("magnify__large-img");
        const e = document.createElement("img");
        e.src = i.getAttribute("src").replace("width=550", "width=2000"), e.loading = "lazy", e.alt = i.getAttribute("alt") + "- Enlarger", s.appendChild(e)
      }
      t.querySelector(".image-container").appendChild(s), this.addEventListener("mousemove", function (e) {
        t.zoom(e, i, s)
      }, !1)
    }
  }
  removeMagnify() {
    this.removeEventListener("mousemove", function (e) {
      self.zoom(e, image_container, largeImg)
    }, !1)
  }
  zoom(e, t, i) {
    let s = t,
      n = i.querySelector("img"),
      o = n.style,
      a = e.clientX - s.getBoundingClientRect().left,
      r = e.clientY - s.getBoundingClientRect().top,
      c = s.offsetWidth,
      d = s.offsetHeight,
      l = a / c * 100,
      u = r / d * 100;
    .01 * c < a && (l += .05 * l), .01 * d <= r && (u += .05 * u), o.transform = `translate(${-1*(-50+l)}%, ${-1*(-50+u)}%)`, i.style.left = a - 50 + "px", i.style.top = r - 50 + "px"
  }
}
customElements.define("image-magnify", Magnify);
class ProductModal extends ModalDialog {
  constructor() {
    super(), this.mediaWrapperSelector = ".product__media-wrapper", this.contentSelector = ".product-media-modal__content", this.modalContent = super.querySelector(this.contentSelector)
  }
  hide() {
    this.scrollY = document.body.style.top, document.body.style.top = "", document.body.classList.remove("overflow-hidden-fixed"), window.scrollTo({
      left: 0,
      top: -1 * parseInt(this.scrollY || "0"),
      behavior: "instant"
    }), this.removeAttribute("open"), this.dispatchEvent(new CustomEvent("modalClose")), this.querySelector(".product__media-wrapper.swiper-initialized") && this.querySelector(".product__media-wrapper").swiper.destroy(), this.querySelector(".product-media-modal__content").innerHTML = "", theme.utils.pauseAllMedia()
  }
  show(e, t = !0) {
    this.openedBy = e, this.setAttribute("open", ""), t && (document.body.style.top = `-${window.pageYOffset}px`, document.body.classList.add("overflow-hidden-fixed")), this.querySelector(".template-popup") && this.querySelector(".template-popup").loadContent(), this.loadContent(), this.showActiveMedia()
  }
  getMediaIdFromOpener() {
    return this.openedBy.closest("modal-opener").querySelector("[data-media-id]").getAttribute("data-media-id")
  }
  loadContent() {
    const e = this.closest(".product-section").querySelector(".product__media--main.product__media-wrapper");
    this.modalContent.innerHTML = "", this.modalContent.appendChild(e.cloneNode(!0)), this.querySelectorAll(".product__media-wrapper img").forEach(e => {
      var t = e.getAttribute("src").replace("width=550", "width=2800 2800w");
      e.setAttribute("srcset", e.getAttribute("srcset") + t), e.setAttribute("sizes", "100vw")
    })
  }
  async showActiveMedia() {
    var e = this.getMediaIdFromOpener();
    this.querySelectorAll(`[data-media-id]:not([data-media-id="${e}"])`).forEach(e => {
      e.classList.remove("active")
    });
    const t = this.querySelector(".product__media-wrapper");
    if (this.querySelectorAll("img", "svg").forEach(e => {
        theme.utils.lazyBackgroundObserver.observe(e)
      }), 780 <= document.documentElement.clientWidth)
      if ("true" == t.getAttribute("data-active")) {
        await this.waitForSwiperInitialization(t);
        var i = parseInt(t.querySelector(`[data-media-id="${this.dataset.section}-${e}"]`).getAttribute("data-index"));
        t.swiper.slideTo(i)
      } else {
        const s = this.querySelector(`[data-media-id="${e}"]`);
        s.classList.add("active"), s.scrollIntoView()
      }
    else {
      e = parseInt(t.querySelector(`[data-media-id="${this.dataset.section}-${e}"]`).getAttribute("data-index"));
      await this.waitForSwiperInitialization(t), t.swiper.slideTo(e)
    }
  }
  async waitForSwiperInitialization(i) {
    return new Promise(e => {
      const t = setInterval(() => {
        i.swiper && (clearInterval(t), e())
      }, 100)
    })
  }
}
customElements.define("product-modal", ProductModal);
class ProductThumbnails extends HTMLElement {
  constructor() {
    super()
  }
  async connectedCallback() {
    var t = this;
    this.container = this.querySelector(".swiper"), await this.waitForSwiperInitialization(), this.initThumbnails(), document.addEventListener("shopify:section:load", async e => {
      t.closest(`#${e.target.id}`) && (await t.waitForSwiperInitialization(), t.initThumbnails())
    }), document.addEventListener("shopify:section:load", e => {
      t.closest(`#${e.target.id}`) && t.initThumbnails()
    })
  }
  waitForSwiperInitialization() {
    return new Promise(e => {
      const t = setInterval(() => {
        this.container.swiper && (clearInterval(t), e())
      }, 200)
    })
  }
  initThumbnails() {
    const t = this;
    if (this.container.swiper) {
      const e = this.closest(".product__left").querySelectorAll(".product__media--main");
      e.forEach(e => {
        e.swiper.thumbs.swiper = this.container.swiper, e.swiper.thumbs.init(), e.swiper.on("activeIndexChange", function (e) {
          var {
            activeIndex: e
          } = e;
          t.container.swiper.slideToLoop(e - 1)
        })
      }), 780 < document.documentElement.clientWidth && this.container.swiper.slides.length < 5 && "vertical" != this.container.dataset.direction && this.querySelector(".swiper-wrapper").classList.add("flex-justify--center")
    }
  }
}
customElements.define("product-thumbnails", ProductThumbnails);
class ProductModel extends DeferredMedia {
  constructor() {
    super()
  }
  loadContent() {
    super.loadContent(), Shopify.loadFeatures([{
      name: "model-viewer-ui",
      version: "1.0",
      onLoad: this.setupModelViewerUI.bind(this)
    }])
  }
  setupModelViewerUI(e) {
    var t, i;
    e || (t = (this.querySelector(".shopify-model-viewer-ui") && (this.querySelector(".shopify-model-viewer-ui").remove(), t = this.querySelector("template").content.firstElementChild.cloneNode(!0), this.appendChild(t)), this.querySelector("model-viewer")), this.modelViewerUI = new Shopify.ModelViewerUI(t), this.closest(".swiper.swiper-initialized") && (i = this.closest(".swiper.swiper-initialized"), this.closest(".swiper-slide-active") && (i.swiper.allowTouchMove = !1), t.addEventListener("shopify_model_viewer_ui_toggle_play", function () {
      this.closest(".swiper-slide-active") && (i.swiper.allowTouchMove = !1)
    }), t.addEventListener("shopify_model_viewer_ui_toggle_pause", function () {
      this.closest(".swiper-slide-active") && (i.swiper.allowTouchMove = !0)
    })))
  }
}
customElements.define("product-model", ProductModel), document.querySelectorAll(".product__media-item a").forEach(e => {
  e.addEventListener("click", function (e) {
    return e.preventDefault(), !1
  })
}), window.ProductModel = {
  loadShopifyXR() {
    Shopify.loadFeatures([{
      name: "shopify-xr",
      version: "1.0",
      onLoad: this.setupShopifyXR.bind(this)
    }])
  },
  setupShopifyXR(e) {
    e || (window.ShopifyXR ? (document.querySelectorAll('[id^="ModelJson-"]').forEach(e => {
      window.ShopifyXR.addModels(JSON.parse(e.textContent)), e.remove()
    }), window.ShopifyXR.setupXRElements()) : document.addEventListener("shopify_xr_initialized", () => this.setupShopifyXR()))
  }
}, window.addEventListener("DOMContentLoaded", () => {
  window.ProductModel && window.ProductModel.loadShopifyXR()
});
class StickyATC extends HTMLElement {
  constructor() {
    super();
    var t = this,
      e = !1,
      i = this.closest(".product-section").querySelector("product-form .product-form__submit");
    (e = i && !i.getAttribute("disabled") ? !0 : e) && (this.visible(), window.addEventListener("scroll", theme.utils.throttle(function () {
      t.visible()
    }, 200)), window.addEventListener("resize", theme.utils.throttle(function () {
      t.visible()
    }, 200)), document.addEventListener("shopify:section:load", function (e) {
      t.visible()
    }), this.isUpdating = !1, this.updateProductOnVariantChange())
  }
  visible() {
    var e = this.closest(".product-section").querySelector("product-form .product-form__submit"),
      t = document.querySelector("footer"),
      i = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
    e && (!this.classList.contains("mu--hide") && 780 < document.documentElement.clientWidth || !this.classList.contains("s--hide") && document.documentElement.clientWidth <= 779) && (theme.utils.isInViewport(e) || i < theme.utils.offset(e).top + e.getBoundingClientRect().height || 0 == i ? this.classList.contains("active") && (this.classList.remove("active"), t.style.marginBottom = "") : this.classList.contains("active") || (this.classList.add("active"), t.style.marginBottom = this.getBoundingClientRect().height + "px"))
  }
  updateProductOnVariantChange() {
    const e = this.querySelector('select[name="id"]');
    e && e.addEventListener("change", e => {
      if (!this.isUpdating) {
        this.isUpdating = !0;
        const t = e.target.value;
        this.querySelector('input[name="id"]').value = t;
        e = document.querySelector(".product-section .variant-select");
        const i = JSON.parse(document.getElementById(`VariantJson-${e.dataset.section}`).textContent);
        e = i.find(e => e.id == t);
        if (e) {
          const s = e.options;
          s.forEach((e, t) => {
            let i = document.querySelector(`.product-section .section-container .variant-select fieldset:nth-of-type(${t+1}) legend`);
            if (i = i || document.querySelector(`.product-section .section-container .variant-select .flex__item:nth-of-type(${t+1}) label`), i) {
              t = i.textContent.trim();
              const s = document.querySelector(`.product-section .section-container input[type="radio"][name="options[${t}]"][value="${e}"]`);
              s && (s.checked = !0, s.dispatchEvent(new Event("change", {
                bubbles: !0
              })));
              const n = document.querySelector(`.product-section .section-container select[name="options[${t}]"]`);
              n && (n.value = e, n.dispatchEvent(new Event("change", {
                bubbles: !0
              })))
            }
          })
        }
        this.isUpdating = !1
      }
    })
  }
}
customElements.define("sticky-atc", StickyATC);

class CountDown extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      days: this.querySelector(".product__countdown-timer-item-days"),
      hours: this.querySelector(".product__countdown-timer-item-hours"),
      minutes: this.querySelector(".product__countdown-timer-item-minutes"),
      seconds: this.querySelector(".product__countdown-timer-item-seconds"),
    };

    this.countdown;

    const date = /\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}/g.test(
      this.dataset.time,
    )
      ? this.dataset.time
      : false;
    if (date != false) {
      this.convertFormat(date);
    }
  }

  convertFormat(str) {
    const [dateComponents, timeComponents] = str.split(" ");

    const [day, month, year] = dateComponents.split("/");
    const [hours, minutes, seconds] = timeComponents.split(":");

    const date = new Date(+year, month - 1, +day, +hours, +minutes, +seconds);

    this.timer(date.getTime());
  }

  timer(seconds) {
    let self = this;

    this.countdown = setInterval(() => {
      let now = Date.now();
      const secondsLeft = Math.round((seconds - now) / 1000);

      if (secondsLeft <= 0) {
        clearInterval(self.countdown);
        return;
      }

      self.displayTimeLeft(secondsLeft);
    }, 1000);
  }

  displayTimeLeft(seconds) {
    this.selectors.days.querySelector(
      ".product__countdown-timer-item-value-base",
    ).textContent =
      Math.floor(seconds / 86400) % 60 < 10
        ? `0${Math.floor(seconds / 86400)}`
        : Math.floor(seconds / 86400);
    this.selectors.hours.querySelector(
      ".product__countdown-timer-item-value-base",
    ).textContent =
      Math.floor((seconds % 86400) / 3600) % 60 < 10
        ? `0${Math.floor((seconds % 86400) / 3600)}`
        : Math.floor((seconds % 86400) / 3600) % 60;
    this.selectors.minutes.querySelector(
      ".product__countdown-timer-item-value-base",
    ).textContent =
      Math.floor(((seconds % 86400) % 3600) / 60) % 60 < 10
        ? `0${Math.floor(((seconds % 86400) % 3600) / 60)}`
        : Math.floor(((seconds % 86400) % 3600) / 60) % 60;
    this.selectors.seconds.querySelector(
      ".product__countdown-timer-item-value-base",
    ).textContent = seconds % 60 < 10 ? `0${seconds % 60}` : seconds % 60;
  }
}
customElements.define("count-down", CountDown);